export const isSuccess = responseCode =>
  responseCode >= 200 && responseCode < 300;
